/**
 * Message qui accompagne le lien de commande : le client sait qu'il peut le
 * poser sur son écran d'accueil, et le transmettre à son équipe.
 *
 * @param {object} client client destinataire
 * @param {string} url lien de commande
 * @param {object} [soc] le magasin
 * @returns {string} le message, vouvoyé
 */
export function messageCommande(client, url, soc) {
  const magasin = soc?.nom || 'notre magasin';
  return (
    'Bonjour ' +
    (client?.contact || client?.nom || '') +
    ',\n\nVoici votre lien de commande ' +
    magasin +
    ' : notre stock à vos prix, commande directe.\n' +
    url +
    '\n\nOuvrez-le, puis ajoutez-le à votre écran d’accueil (la page vous montre comment) : vous commanderez en un geste. Vous pouvez aussi le transmettre à votre équipe.\n\n' +
    magasin
  );
}
